import type { AllowedEmailDomain } from "../types/database";
import { supabase } from "./supabase";

export async function listAllowedDomains(): Promise<AllowedEmailDomain[]> {
  const { data, error } = await supabase
    .from("allowed_email_domains")
    .select("domain, university_name")
    .order("university_name");
  if (error || !data) return [];
  return data as AllowedEmailDomain[];
}

export function getEmailDomain(email: string): string {
  const at = email.lastIndexOf("@");
  return at < 0 ? "" : email.slice(at + 1).toLowerCase().trim();
}

export function isEmailDomainAllowed(email: string, allowed: AllowedEmailDomain[]): boolean {
  const domain = getEmailDomain(email);
  return !!domain && allowed.some((a) => a.domain.toLowerCase().trim() === domain);
}

/** First whitelist row whose domain matches the email's domain (case-insensitive). */
export function matchEmailDomain(email: string, allowed: AllowedEmailDomain[]): AllowedEmailDomain | null {
  const domain = getEmailDomain(email);
  if (!domain) return null;
  const hit = allowed.find((a) => a.domain.toLowerCase().trim() === domain);
  return hit ?? null;
}
